import isObject from "lodash/isObject";
import some from "lodash/some";

type CheckIsDirtyOptions = {
  simplified?: boolean;
};

export const checkIsDirty = (obj: any, options?: CheckIsDirtyOptions) => {
  if (options?.simplified) {
    return (JSON.stringify(obj) || "").includes("true");
  }

  if (isObject(obj)) {
    return some(obj, (value) => checkIsDirty(value, options));
  }

  return !!obj;
};
